import { STATIC_IMAGE_BASE } from '@mc/constants'
import i18nInstance from './i18n/i18nInstance'

// Session with partnerships (used in pre & post-paywall)
export const FLORAL_DESIGN_SLUG = 'design-stunning-floral-arrangements'
export const PLAN_YOUR_DREAM_WEDDING_SLUG = 'plan-your-dream-wedding'
export const STYLE_YOUR_OWN_HAIR_FOR_ANY_OCCASION_SLUG =
  'style-your-own-hair-for-any-occasion'

interface Partnerships {
  [name: string]: {
    title: string
    description: string
    image: string
  }
}

const t = i18nInstance.getFixedT(null, '@mc/sessions-utils')

const PARTNERSHIPS = {
  [FLORAL_DESIGN_SLUG]: {
    title: t('specialPartnership.mha.title'),
    description: t('specialPartnership.mha.description'),
    image: `${STATIC_IMAGE_BASE}/sessions/floral-design.jpg`,
  },
  [PLAN_YOUR_DREAM_WEDDING_SLUG]: {
    title: t('specialPartnership.mws.title'),
    description: t('specialPartnership.mws.description'),
    image: `${STATIC_IMAGE_BASE}/sessions/minted-image.jpg`,
  },
  [STYLE_YOUR_OWN_HAIR_FOR_ANY_OCCASION_SLUG]: {
    title: t('specialPartnership.jatk.title'),
    description: t('specialPartnership.jatk.description'),
    image: `${STATIC_IMAGE_BASE}/sessions/ouai-jen-atkin.jpg`,
  },
} as Partnerships

export const getSpecialPartnership = (slug: string) => PARTNERSHIPS[slug]
